import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const tomos = [{
  number: 'Tomo 1',
  emoji: '📘',
  title: 'El Escudo Familiar',
  description: 'Cocina segura, viandas escolares y compras inteligentes. Sin miedo a contaminar. Sin improvisar.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/6713c50b-ebe5-4e4d-b9f0-a2be69ba8ec2.jpg',
  alt: 'Portada del Tomo 1: El Escudo Familiar'
}, {
  number: 'Tomo 2',
  emoji: '🍳',
  title: 'Cenas Rápidas y Post-Laburo',
  description: 'Cenas sin TACC en 15 minutos de lunes a viernes. Sistema one-pot, batch cooking y menú semanal listo.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/42a1f396-f178-4a35-b0a2-1a3b4e291e44.jpg',
  alt: 'Portada del Tomo 2: Cenas Rápidas y Post-Laburo'
}, {
  number: 'Tomo 3',
  emoji: '🥐',
  title: 'Panadería y Dulces Patrios',
  description: 'Pan, pizza, chipá, alfajores y tortas sin TACC. Para que tu hijo no se quede afuera nunca más.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/ca6c66ed-6e07-484c-a1cc-76be44510489.jpg',
  alt: 'Portada del Tomo 3: Panadería y Dulces Patrios'
}];
const includes = ['Recetas paso a paso', 'Checklists', 'Listas de compras', 'Sistema de freezer', '100% Argentina'];
export function Tomos() {
  return <section id="sistema" className="w-full bg-forest-dark px-5 py-16 sm:px-8 lg:py-24" data-id="element-176" data-mp="3sgapqstg0kvj">
      <div className="mx-auto max-w-6xl" data-id="element-177" data-mp="19zs76nn628y">
        <SectionHeading tone="light" eyebrow="🏆 El sistema completo" title="Mega Pack Tu Comida Celíaca" subtitle="3 Tomos · 150 páginas · Todo listo para usar" data-id="element-178" data-mp="1bazhggaps4t" />

        <ul className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-179" data-mp="232xhwtm4gepo">
          {tomos.map((t, i) => <motion.li key={t.number} initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1,
          ease: 'easeOut'
        }} className="group flex flex-col overflow-hidden rounded-3xl border border-cream/12 bg-cream/5 transition-colors duration-300 hover:border-cream/25" data-id="element-180" data-mp="280zbw9l35yfx" data-mpi={i}>
              <div className="aspect-[3/4] overflow-hidden bg-cream-deep" data-id="element-181" data-mp="2iydn7rnqf73d">
                <img src={t.image} alt={t.alt} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]" loading="lazy" data-id="element-182" data-mp="2iw9coqvbv9u4" />
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-183" data-mp="2npvqimd89jri">
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-wheat" data-id="element-184" data-mp="32m3bhowgmp7u">
                  {t.emoji} {t.number}
                </p>
                <h3 className="mt-2 font-display text-2xl leading-tight text-cream" data-id="element-185" data-mp="2xpcu8y8x5nku">
                  {t.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-cream/70" data-id="element-186" data-mp="3lan8ek5iuvmq">
                  {t.description}
                </p>
              </div>
            </motion.li>)}
        </ul>

        <div className="mt-10 rounded-2xl border border-cream/12 bg-cream/5 p-6" data-id="element-187" data-mp="3ca8n3ksk5gj8">
          <p className="mb-4 text-sm font-semibold uppercase tracking-[0.16em] text-cream/60" data-id="element-188" data-mp="3cc1skwrfpupn">
            Cada tomo incluye
          </p>
          <ul className="flex flex-wrap gap-x-6 gap-y-3" data-id="element-189" data-mp="32cawwrr519nz">
            {includes.map(item => <li key={item} className="inline-flex items-center gap-2 text-sm text-cream/85" data-id="element-190" data-mp="2olfkx6lcecg6">
                <CheckIcon className="h-4 w-4 shrink-0 text-wheat" strokeWidth={2.5} aria-hidden="true" data-id="element-191" data-mp="2tjz7n97rfs9l" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}